<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container
    :use-return="true"
    @back="back"
  >
    <template #title>
      <div class="text-h3">
        {{ $t('YouManageMultipleStores') }}
      </div>
    </template>

    <div class="d-flex mt-4 py-4">
      <v-card
        class="pa-4 px-6 text-h5 font-weight-medium mr-4"
        elevation="0"
        @click="next(true)"
      >
        {{ $t('YesManageMultipleStores') }}
      </v-card>
      <v-card
        class="pa-4 px-6 text-h5 "
        elevation="0"
        @click="next(false)"
      >
        {{ $t('CurrentlyManageOneShop') }}
      </v-card>
    </div>
  </saa-s-child-page-container>
</template>

<script>

import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import { selectIsChain } from '@/views/SaaS/SaaSGuide'

export default {
  name: 'SelectChainStores',
  components: {
    SaaSChildPageContainer
  },
  data: function () {
    return {}
  },
  methods: {
    back () {
      this.$router.push({ name: 'choose-store-type' })
    },
    next (multiple = false) {
      selectIsChain(multiple)
      this.$router.push({ name: 'recommended' })
    }
  }
}
</script>

<style scoped>

</style>
